// What the drawer says while a Copilot tool is running.
//
// The clinic reads the work, not the tool name: a running `list_schedulings`
// is "Consultando a agenda…", not "Executando list_schedulings...". A tool with
// no entry here falls back to the neutral sentence instead of leaking an
// internal identifier into the panel.

export const DEFAULT_TOOL_STREAMING_LABEL = "Trabalhando…";

export const TOOL_STREAMING_LABELS: Readonly<Record<string, string>> = {
  // Agenda
  list_schedulings: "Consultando a agenda…",
  smart_agenda_review: "Consultando a agenda…",
  get_waitlist_status: "Consultando a agenda…",
  send_confirmations: "Consultando a agenda…",
  draft_appointment: "Preparando o agendamento…",
  draft_register_and_schedule: "Preparando o cadastro e o agendamento…",
  confirm_appointment: "Salvando o agendamento…",
  // Patients
  list_patients: "Procurando o paciente…",
  get_patient_detail: "Procurando o paciente…",
  draft_patient: "Preparando o cadastro…",
  draft_patient_update: "Preparando o cadastro…",
  confirm_patient: "Salvando o cadastro…",
  confirm_patient_update: "Salvando o cadastro…",
  // Clinic data
  list_stock_items: "Verificando o estoque…",
  draft_stock_item: "Preparando o item de estoque…",
  list_employees: "Consultando a equipe…",
  list_procedures: "Consultando os procedimentos…",
  get_dashboard_metrics: "Calculando os indicadores…",
  morning_briefing: "Preparando o briefing do dia…",
};

export function toolStreamingLabel(toolName: string): string {
  return TOOL_STREAMING_LABELS[toolName] ?? DEFAULT_TOOL_STREAMING_LABEL;
}
